import { Mixins } from 'vue-property-decorator';
import '@/assets/stylesheets/v2/_mdr-dialog.scss';
export default class SampleNetPayComputationDialog extends Mixins() {
    confirm() {
        this.$emit('confirm');
    }
    back() {
        this.$emit('back');
    }
}
